import React, { useState } from "react"
import SchedulePage from "../../index.jsx"
import ScheduleHeader from "../../Header.jsx"
import ModuleTitle from "../../../../atoms/SchedulePages/ModuleTitle.jsx"
import { Schedule, ScheduleTable } from "../../ScheduleTable.jsx"

import { PickupLocations, PickupLocation } from "../../Locations.jsx"
import { WaterlooLocations } from "../pickup-locations.js"
import {
  WaterlooMeta,
  WaterlooFares,
  NavigationItems,
  TravelingData,
  AmenitiesList,
} from "../metadata.js"
import {
  WaterlooMetaFR,
  WaterlooFaresFR,
  NavigationItemsFR,
  TravelingDataFR,
  AmenitiesListFR,
} from "../metadata-fr.js"
import { WaterlooData } from "../schedule.js"
import CanadaAmenities from "../Amenities.jsx"
import Seo from "../../../../molecules/Seo/index.jsx"
import ScheduleNavigation from "../../Navigation.jsx"
import { Fares, FaresTable } from "../Fares.jsx"
import TravelingCanada from "../TravelingCanada.jsx"
import { WaterlooLocationsFR } from "../pickup-locations-fr.js"

const WaterlooSchedule = () => {
  const [content, setContent] = useState({
    meta: WaterlooMeta,
    data: WaterlooData,
    fares: WaterlooFares,
    navigation: NavigationItems,
    traveling: TravelingData,
    amenities: AmenitiesList,
    locations: WaterlooLocations,
    english: true,
    french: false,
  })

  const switchLanguage = () => {
    if (content.english) {
      setContent(prev => ({
        ...prev,
        meta: WaterlooMetaFR,
        fares: WaterlooFaresFR,
        navigation: NavigationItemsFR,
        locations: WaterlooLocationsFR,
        traveling: TravelingDataFR,
        amenities: AmenitiesListFR,
        english: false,
        french: true,
      }))
    } else {
      setContent(prev => ({
        ...prev,
        meta: WaterlooMeta,
        fares: WaterlooFares,
        navigation: NavigationItems,
        locations: WaterlooLocations,
        traveling: TravelingData,
        amenities: AmenitiesList,
        english: true,
        french: false,
      }))
    }
  }

  return (
    <SchedulePage
      phone="+12494920941"
      phone_text="(249) 492-0941"
      renderCanadaMenu={true}
      renderTabs={false}
      isFrench={content.french}
      switchLanguage={switchLanguage}
      hideFaq={true}
      hideSubscribe={true}
    >
      <Seo
        title={content.meta.seo.title}
        description={content.meta.seo.description}
        canonicalUrl={"https://landline.com/canada/waterloo"}
      />
      {/* <div className="schedule-search-form">
        <Search history={history} remoteCallSearchComponent={true} />
      </div> */}
      <div className="schedule-page">
        <ScheduleHeader metadata={content.meta.header} />

        <ScheduleNavigation items={content.navigation} />

        <ModuleTitle title={content.meta.titles.schedule} navigationid="schedule" />
        <Schedule book_url="https://ca.landline.com/">
          <ScheduleTable schedule={content.data.from} />
          <ScheduleTable schedule={content.data.to} />
        </Schedule>

        <PickupLocations>
          {content.locations.map(location => {
            return <PickupLocation location={location} />
          })}
        </PickupLocations>

        <ModuleTitle title={content.meta.titles.fares} navigationid="fares" />
        <Fares>
          <FaresTable fares={content.fares} />
        </Fares>

        <TravelingCanada content={content.traveling} />

        <ModuleTitle title={content.meta.titles.amenities} navigationid="amenities" />
        <CanadaAmenities amenities={content.amenities} />
      </div>
    </SchedulePage>
  )
}

export default WaterlooSchedule
